export default __webpack_public_path__ + "static/media/62.b7962af3.png";